import { filterData } from "@/lib";
import { createSlice } from "@reduxjs/toolkit";
 
export const errorSlice = createSlice({
  name: "errorInfo",
  initialState: {
    errorlist: [],
  },
  reducers: {
    collectErrors: (state, action) => {
      const errorlist = action.payload;
      state.errorlist.push(errorlist);
    },
    // eslint-disable-next-line no-unused-vars
    clearAllError: (state, action) => {
      state.errorlist = [];
    },
    clearErrors: (state, action) => {
      const existingerrorlist = JSON.parse(JSON.stringify(state.errorlist));

      const { tablename, timestamp } = action.payload;
      const filteredData = filterData(existingerrorlist, timestamp, tablename);

      state.errorlist = filteredData;
    },
  },
});

export const { collectErrors, clearErrors, clearAllError } = errorSlice.actions;

export default errorSlice.reducer;
